const sectionFreestyleOrderPolicyCss = `
[data-type='section-freestyle-order-policy'] [data-attribute='content'] {
  padding-top: var(--padding-top-desktop, 4px);
  padding-bottom: var(--padding-bottom-desktop, 4px);
}

[data-type='section-freestyle-order-policy'] [data-attribute='content'] figure {
  overflow-x: auto;
  overflow-y: hidden;
}

[data-type='section-freestyle-order-policy'] [data-attribute='content'] h1,
[data-type='section-freestyle-order-policy'] [data-attribute='content'] h2,
[data-type='section-freestyle-order-policy'] [data-attribute='content'] h3 {
  font-size: 24px;
  line-height: normal;
  margin: 0 0 6px 0 !important;
}

[data-type='section-freestyle-order-policy'] [data-attribute='content'] h1:last-child,
[data-type='section-freestyle-order-policy'] [data-attribute='content'] h2:last-child,
[data-type='section-freestyle-order-policy'] [data-attribute='content'] h3:last-child {
  margin-bottom: 0 !important;
}

[data-type='section-freestyle-order-policy'] [data-attribute='content'] p {
  font-size: 14px;
  line-height: normal;
  margin: 0 0 4px 0 !important;
}

[data-type='section-freestyle-order-policy'] [data-attribute='content'] p:last-child {
  margin-bottom: 0 !important;
}

@container (max-width: 768px) {
  [data-type='section-freestyle-order-policy'] [data-attribute='content'] {
    padding-top: var(--padding-top-mobile, 4px);
    padding-bottom: var(--padding-bottom-mobile, 4px);
  }

  [data-type='section-freestyle-order-policy'] [data-attribute='content'] h1,
  [data-type='section-freestyle-order-policy'] [data-attribute='content'] h2,
  [data-type='section-freestyle-order-policy'] [data-attribute='content'] h3 {
    font-size: 20px;
  }

  [data-type='section-freestyle-order-policy'] [data-attribute='content'] p {
    font-size: 12px;
  }
}
`;
export default sectionFreestyleOrderPolicyCss;
